import { put, call } from 'redux-saga/effects';

import { Types } from './actions';

import RectificationRepository from '@/domain/repositories/RectificationRepository';
import RectificationNotesDataRepository from '@/data/repositories/RectificationNotesDataRepository';

export default function* execute(action: any): any {
  try {
    const { courseId, catalog } = action;
    yield put({ type: Types.GET_EVALUATIONS_TO_BE_CORRECTED_REQUEST });

    const rectificationRepository: RectificationRepository =
      new RectificationNotesDataRepository();
    const rectificationNotesResponse = yield call(
      rectificationRepository.getEvaluationsToBeCorrected,
      courseId,
      catalog
    );

    if (!rectificationNotesResponse) {
      yield put({
        type: Types.GET_EVALUATIONS_TO_BE_CORRECTED_FAILURE,
        error: true
      });
      return;
    }
    yield put({
      type: Types.GET_EVALUATIONS_TO_BE_CORRECTED_SUCCESS,
      data: rectificationNotesResponse
    });
  } catch (error) {
    yield put({
      type: Types.GET_EVALUATIONS_TO_BE_CORRECTED_FAILURE,
      error: 'Ocurrió un error al momento de solicitar los datos.'
    });
  }
}
